import {
  call, put, takeLatest, select, takeEvery, delay,
} from 'redux-saga/effects';
import { change, stopSubmit } from 'redux-form';
import { callApi } from './loadingSaga';
import * as Actions from '../actions/schoolEntryActions';
import Api from '../api/schoolEntryApi';

export function* initialize() {
  const { initial } = yield select((state) => state.form.schoolEntryIndex);
  if (initial.school_application === undefined
    || initial.school_application.school_location_id === null
    || initial.school_application.school_location_id === 'お選びください') {
    return;
  }

  yield put({
    type: Actions.SAGA_GET_DAY_LOCATIONS,
    payload: { schoolLocationId: initial.school_application.school_location_id },
  });

  if (initial.school_application.day_location_id === undefined
      || initial.school_application.day_location_id === 'お選びください'
  ) {
    return;
  }

  yield put({
    type: Actions.SAGA_GET_COURSES,
    payload: { dayLocationId: initial.school_application.day_location_id },
  });

  if (initial.school_application.course_id === undefined
      || initial.school_application.course_id === 'お選びください'
  ) {
    return;
  }

  yield put({
    type: Actions.SAGA_GET_PC_TYPES,
    payload: { courseId: initial.school_application.course_id },
  });

  yield put({ type: Actions.SAGA_GET_PRICES });
}

export function* onChangeFormInput(action) {
  const { form, field } = action.meta;
  if (form === 'schoolEntryIndex') {
    if (field === 'school_application[school_location_id]') {
      if (action.payload === undefined || action.payload === 'お選びください') {
        yield put(Actions.setCourses([]));
        yield put(Actions.setDayLocations([]));
      } else {
        yield put({
          type: Actions.SAGA_GET_DAY_LOCATIONS,
          payload: { schoolLocationId: action.payload },
        });
      }
      yield put(change('schoolEntryIndex', 'school_application[day_location_id]', undefined));
      yield put(change('schoolEntryIndex', 'school_application[course_id]', undefined));
    }
    if (field === 'school_application[day_location_id]') {
      if (action.payload === undefined || action.payload === '' || action.payload === 'お選びください') {
        yield put(Actions.setCourses([]));
        yield put(Actions.setPcTypes([]));
        yield put(Actions.setPrices({}));
      } else {
        const { school_application } = yield select((state) => state.form.schoolEntryIndex.values);
        yield put({
          type: Actions.SAGA_GET_COURSES,
          payload: { dayLocationId: school_application.day_location_id },
        });
        yield put({ type: Actions.SAGA_GET_PRICES });
      }
      yield put(change('schoolEntryIndex', 'school_application[course_id]', undefined));
    }
    if (field === 'school_application[course_id]' && action.payload !== undefined && action.payload !== 'お選びください') {
      yield put({
        type: Actions.SAGA_GET_PC_TYPES,
        payload: { courseId: action.payload },
      });
      yield put({ type: Actions.SAGA_GET_PRICES });
    }
    if (field === 'student_id') {
      yield put({ type: Actions.SAGA_GET_PRICES });
    }
    if (field === 'coupon_code') {
      yield put({ type: Actions.SAGA_GET_PRICES });
    }
  }
}

export function* getDayLocations(action) {
  const { dayLocations } = yield call(callApi, Api.getDayLocations, action.payload.schoolLocationId);
  yield put(Actions.setDayLocations(dayLocations));
}

export function* getCourses(action) {
  const { courses } = yield call(callApi, Api.getCourses, action.payload.dayLocationId);
  yield put(Actions.setCourses(courses));
}

export function* getPrices() {
  const { values } = yield select((state) => {
    if (state.form.schoolEntryIndex !== undefined) return state.form.schoolEntryIndex;
    if (state.form.schoolEntryConfirm !== undefined) return state.form.schoolEntryConfirm;
    if (state.form.Credit !== undefined) return state.form.Credit;
  });
  if (!values.school_application.day_location_id) {
    return;
  }
  const { continued } = yield select((state) => state.schoolEntry);
  const prices = yield call(callApi, Api.getPrices, values.school_application.day_location_id, values.student_id === 'new' ? null : values.student_id, values.coupon_code, continued);
  yield put(Actions.setIsFreeTrial(prices.freeTrialCampJoined || prices.freeTrialCouponUsed));
  yield put(Actions.setInnovationStudioSelected(prices.innovationStudioSelected));
  yield put(Actions.setPrices(prices));
}

export function* getPcTypes(action) {
  if (action.payload.courseId === '') {
    return;
  }
  const { pcTypes } = yield call(callApi, Api.getPcTypes, action.payload.courseId);
  yield put(Actions.setPcTypes(pcTypes.map((x) => ({ id: x[0], name: x[1] }))));
}

export function* openPopOver() {
  yield put(Actions.setOpenPopover(true));
  yield delay(4000);
  yield put(Actions.setOpenPopover(false));
}

export function* setPcType(action) {
  yield call(callApi, Api.setPcType, action.payload.schoolApplicationId, action.payload.pcTypeId);
  yield put(stopSubmit('setPcTypeModalForm'));
  const { errorMessage } = yield select((state) => state.schoolEntry);
  if (errorMessage === null) {
    yield put(Actions.setPcSucceed());
  }
}

export default function* schoolEntrySaga() {
  yield takeLatest(Actions.SAGA_INITIALIZE, initialize);
  yield takeEvery('@@redux-form/CHANGE', onChangeFormInput);
  yield takeLatest(Actions.SAGA_GET_COURSES, getCourses);
  yield takeLatest(Actions.SAGA_GET_DAY_LOCATIONS, getDayLocations);
  yield takeLatest(Actions.SAGA_GET_PRICES, getPrices);
  yield takeLatest(Actions.SAGA_GET_PC_TYPES, getPcTypes);
  yield takeLatest(Actions.SAGA_OPEN_POP_OVER, openPopOver);
  yield takeLatest(Actions.SAGA_SET_PC_TYPE, setPcType);
}
